<template>
  <button v-if="visible" id="GoTop" type="button" @click="goTop">
    <img class="glyphicon" src="../assets/images/top.png" alt="返回顶部" />
  </button>
</template>

<script>
export default {
  name: 'GoTop',
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.visible = scrollTop > 280
    }
  }
}
</script>

<style scoped>
#GoTop {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 99;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  cursor: pointer;
  border-radius: 18px;
  background: rgba(250, 249, 245, 0.95);
  box-shadow: 0 16px 34px rgba(20, 20, 19, 0.12),
    0 0 0 1px rgba(209, 207, 197, 0.9);
}

.glyphicon {
  display: block;
  width: 26px;
  height: 26px;
}

@media screen and (max-width: 640px) {
  #GoTop {
    right: 16px;
    bottom: 16px;
    width: 46px;
    height: 46px;
  }
}
</style>
